import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Divider, Grid, Paper } from "@material-ui/core";
import TableToolbar from "../../../components/data-table/toolbar";
import glassesService from "../../../services/glasses.service";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "../../../components/formik-material-ui";
import MuiSwitch from "@material-ui/core/Switch";
import { useSnackbar } from "notistack";
import GroupsToChange from "./GroupChange";


export default function ChangeGrouply(props) {

    const { enqueueSnackbar } = useSnackbar();

    const [extra, setExtra] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [firstTimeConfirm, setFirstTimeConfirm] = useState(null);
    const [filters, setFilters] = useState({
        brand: null,
        updateOption: null,
        allGlasses: false,
        changePrice: 0,
        changeDiscount: 0,
    })


    const handleChangeValue = (key, value) => {
        setFirstTimeConfirm(null)
        setFilters(prev => ({
            ...prev,
            [key]: value
        }))
    }

    const getExtra = async () => {
        let query = [
            `page=1`,
            `perpage=1`,
        ];

        const { data, error } = await glassesService.getGlasses(query);

        if (error) {
            return;
        }

        if (!extra) {
            setExtra(data.extra)
        }
    }

    const getOptionLabel = () => {
        const labelSelector = "title";
        if (!labelSelector) return;
        if (typeof labelSelector === "string") {
            return (option) => `${option[labelSelector]}`;
        }
        return labelSelector;
    };

    const handleConfirm = async () => {
        if (firstTimeConfirm !== null) {
            await handleSubmitForm();
            return;
        }

        let errors = [];
        let queryFilter = setFilterQuery()

        if (!filters.updateOption?.value) {
            errors.push("نوع تغییر را مشخص کنید")
        }

        if (!filters.allGlasses && queryFilter.length === 0) {
            errors.push("فیلتر عینک را مشخص کنید")
        }

        if (filters?.updateOption?.value === "changePrice") {
            if (!filters.changePrice) {
                errors.push("مقدار تغییر قیمت را مشخص کنید");
            }
        }
        if (filters?.updateOption?.value === "changeDiscount") {
            if (!filters.changeDiscount) {
                errors.push("مقدار تغییر را مشخص کنید");
            }
        }

        if (errors.length > 0) {
            errors.forEach(err => {
                enqueueSnackbar(err, { variant: "error" });
            })
        }
        else {
            setIsLoading(true);
            const res = await glassesService.countOfGlassFilter(queryFilter);
            setFirstTimeConfirm(res.data.count)
            setIsLoading(false);
        }
    }

    const handleSubmitForm = async () => {
        const queryFilter = setFilterQuery();
        setIsLoading(true);
        await glassesService.handleChangeGrouply(queryFilter, {
            updateType: filters?.updateOption?.value,
            changePrice: filters.changePrice,
            changeDiscount: filters.changeDiscount,
        })

        if (filters.updateOption.value === "changePrice") {
            enqueueSnackbar(`تغییر قیمت روی ${firstTimeConfirm} عینک اعمال شد`, { variant: "success" });
        }
        if (filters.updateOption.value === "changeDiscount") {
            enqueueSnackbar(`تخفیف روی ${firstTimeConfirm} عینک اعمال شد`, { variant: "success" });
        }
        setFirstTimeConfirm(null)
        setIsLoading(false);
    }

    const setFilterQuery = () => {
        let queryFilter = []
        if (!filters.allGlasses) {
            if (filters.brand && filters.brand?.length > 0) {
                filters.brand.forEach(it => queryFilter.push(`brandIds[]=${it.value}`))
            }
        }

        return queryFilter
    }

    useEffect(() => {
        getExtra()
    }, []);

    const brandOptions = extra?.brands.length > 0 ? extra?.brands.map(item => ({ title: item.name, value: item.id })) : []

    return (
        <div className="p-1">
            <Paper className="mt-2 glass p-2">
                <TableToolbar
                    selectedRows={[]}
                    multiRowActions={false}
                    title={"تغییرات گروهی"}
                />
                <Grid container spacing={2}>
                    <Grid items xs={12}>
                        <Grid items xs={2} className="p-1">
                            <label>همه عینک ها</label>
                            <MuiSwitch
                                label="همه عینک ها"
                                name="allGlasses"
                                value={filters.allGlasses}
                                onChange={(e) => handleChangeValue("allGlasses", e.target.checked)}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                {
                    !filters.allGlasses &&
                    <Grid container spacing={2}>
                        <Grid items xs={6} className="p-1">
                            <MuiAutocomplete
                                multiple={true}
                                options={brandOptions}
                                getOptionLabel={getOptionLabel()}
                                noOptionsText="هیچ گزینه ای یافت نشد."
                                onChange={(e, values) => handleChangeValue('brand', values)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        margin="normal"
                                        variant="outlined"
                                        fullWidth
                                        label={"برند"}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                }


                <Grid container spacing={2}>
                    <Grid items xs={2} className="p-1">
                        <MuiAutocomplete
                            multiple={false}
                            options={[
                                { title: "تغییر قیمت", value: "changePrice" },
                                { title: "درصد تخفیف", value: "changeDiscount" },
                            ]}
                            getOptionLabel={getOptionLabel()}
                            noOptionsText="هیچ گزینه ای یافت نشد."
                            onChange={(e, values) => handleChangeValue('updateOption', values)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="normal"
                                    variant="outlined"
                                    fullWidth
                                    label={"نوع تغییر"}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid items xs={2} className="p-1 d-flex align-center">

                        {
                            filters?.updateOption?.value === "changePrice" &&
                            <TextField
                                label="درصد تغییر قیمت"
                                value={filters.changePrice || 0}
                                variant="outlined"
                                fullWidth
                                field={{
                                    onChange: (e) => handleChangeValue("changePrice", e.target.value)
                                }}
                                inputProps={{
                                    min: 0,
                                    max: 100,
                                }}
                            />
                        }

                        {
                            filters?.updateOption?.value === "changeDiscount" &&
                            <TextField
                                label="درصد تخفیف"
                                value={filters.changeDiscount || 0}
                                variant="outlined"
                                fullWidth
                                field={{
                                    onChange: (e) => handleChangeValue("changeDiscount", e.target.value)
                                }}
                                inputProps={{
                                    min: 0,
                                    max: 100,
                                }}
                            />
                        }
                    </Grid>
                </Grid>

                <Grid container spacing={2}>
                    <Grid items xs={10}>
                    </Grid>
                    <Grid items xs={2}>
                        <div className="d-flex">
                            <div style={{ marginRight: "auto" }}>
                                <Button
                                    onClick={handleConfirm}
                                    variant="contained"
                                    color="primary"
                                    disabled={isLoading}
                                >
                                    {
                                        isLoading
                                            ? <CircularProgress color="inherit" size={20} />
                                            : firstTimeConfirm === null ? "تایید" : `اعمال بر ${firstTimeConfirm} عینک`
                                    }
                                </Button>
                            </div>
                        </div>

                    </Grid>
                </Grid>
            </Paper>

            <GroupsToChange />
        </div>
    )
}